module.exports = __webpack_public_path__ + "assets/img/pages/about/people/jens-ahrens.png";